/**
 * Product form variant handling - Shopify 2.0 compliant
 * Syncs: variant id, price, availability, add-to-cart, gallery image, quantity
 * For product-template.liquid (Flickity gallery, legacy option structure)
 */
(function () {
  "use strict";

  var PRODUCT_SECTION = '[data-section-type="product"]';

  function formatMoney(cents) {
    if (
      typeof Shopify !== "undefined" &&
      typeof Shopify.formatMoney === "function"
    ) {
      return Shopify.formatMoney(cents);
    }
    var format =
      (window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.moneyFormat) ||
      "{{amount}}";
    return format
      .replace("{{amount}}", (cents / 100).toFixed(2))
      .replace("{{amount_no_decimals}}", Math.round(cents / 100));
  }

  function getProductData(container) {
    var script =
      container && container.querySelector("script[data-product-json]");
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function findVariantByOptions(product, optionValues) {
    var variants = product.product && product.product.variants;
    if (!variants || !Array.isArray(optionValues)) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < optionValues.length; j++) {
        var opt = "option" + (j + 1);
        if (v[opt] !== optionValues[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function getSelectedOptions(form) {
    var inputs = form.querySelectorAll("input[data-option-position]:checked");
    var maxPos = 0;
    var opts = [];
    for (var i = 0; i < inputs.length; i++) {
      var pos = parseInt(inputs[i].getAttribute("data-option-position"), 10);
      if (pos > maxPos) maxPos = pos;
      opts[pos - 1] = inputs[i].value;
    }
    return opts.slice(0, maxPos);
  }

  function updateVariantInForm(form, variant, productData) {
    var idInput = form.querySelector("[data-variant-id-input]");
    if (!idInput) return;
    idInput.value = variant ? variant.id : "";
    if (idInput.hasAttribute("data-sku") && variant) {
      idInput.setAttribute("data-sku", variant.sku || "");
    }

    var addBtn = form.querySelector(
      '.hw--addToCartButton, [data-action="add-to-cart"]',
    );
    if (addBtn) {
      if (variant && variant.available) {
        addBtn.removeAttribute("disabled");
        addBtn.setAttribute("data-action", "add-to-cart");
      } else {
        addBtn.setAttribute("disabled", "disabled");
        addBtn.removeAttribute("data-action");
      }
    }

    var priceList = document.querySelector(".ProductMeta__PriceList");
    if (priceList && variant) {
      var hasCompare =
        variant.compare_at_price && variant.compare_at_price > variant.price;
      var html = "";
      if (hasCompare) {
        html =
          '<span class="ProductMeta__Price Price Price--highlight" data-money-convertible>' +
          formatMoney(variant.price) +
          "</span>" +
          '<span class="ProductMeta__Price Price Price--compareAt" data-money-convertible>' +
          formatMoney(variant.compare_at_price) +
          "</span>" +
          '<span class="badge_label">SALE</span>';
      } else {
        html =
          '<span class="ProductMeta__Price Price" data-money-convertible>' +
          formatMoney(variant.price) +
          "</span>";
      }
      priceList.innerHTML = html;
    }

    var invEl = form.querySelector(".ProductForm__Inventory");
    if (invEl && productData && productData.inventories && variant) {
      var inv = productData.inventories[variant.id];
      if (inv && inv.inventory_message) {
        invEl.textContent = inv.inventory_message;
        invEl.style.display = "";
      } else {
        invEl.style.display = "none";
      }
    }

    if (form.dispatchEvent) {
      form.dispatchEvent(
        new CustomEvent("variant:change", {
          bubbles: true,
          detail: { variant: variant, formId: form.id },
        }),
      );
    }
  }

  function updateGalleryImage(section, variant) {
    if (!variant) return;
    var mediaId =
      (variant.featured_media && variant.featured_media.id) ||
      (variant.featured_image && variant.featured_image.id);
    if (!mediaId) return;
    var slides = section.querySelectorAll(".Product__SlideItem[data-image-id]");
    var idx = -1;
    for (var i = 0; i < slides.length; i++) {
      if (parseInt(slides[i].getAttribute("data-image-id"), 10) === mediaId) {
        idx = i;
        break;
      }
    }
    if (idx >= 0 && window.Flickity) {
      var mainSlideshow = section.querySelector(
        ".Product__Slideshow--zoomable, .Product__Slideshow",
      );
      var thumbSlideshow = section.querySelector(
        ".Product__SlideshowNav--thumbnails",
      );
      var mainFlickity = mainSlideshow && Flickity.data(mainSlideshow);
      var thumbFlickity = thumbSlideshow && Flickity.data(thumbSlideshow);
      if (mainFlickity) mainFlickity.select(idx, false, false);
      if (thumbFlickity) thumbFlickity.select(idx, false, false);
      var scrollers = section.querySelectorAll(
        ".Product__SlideshowNavScroller",
      );
      scrollers.forEach(function (s, i) {
        if (i === idx) {
          s.classList.add("is-selected", "is-nav-selected");
        } else {
          s.classList.remove("is-selected", "is-nav-selected");
        }
      });
    }
  }

  function syncHwSelect(form, variant) {
    var hwSelect = document.querySelector(".hw--select select");
    if (!hwSelect || !variant) return;
    var opt1 = variant.option1 || "";
    var options = hwSelect.querySelectorAll("option");
    for (var i = 0; i < options.length; i++) {
      if (options[i].getAttribute("orig-value") === opt1) {
        hwSelect.selectedIndex = i;
        break;
      }
    }
  }

  function syncSelectedValueDisplay(form, variant) {
    var labels = form.querySelectorAll(".ProductForm__SelectedValue");
    if (!variant) return;
    var opts = [variant.option1, variant.option2, variant.option3].filter(
      Boolean,
    );
    labels.forEach(function (lbl, i) {
      if (opts[i]) lbl.textContent = opts[i];
    });
  }

  function initProductForm(section) {
    var form = section.querySelector("form.ProductForm");
    if (!form) return;
    var productData = getProductData(form.closest(".Product") || section);
    if (!productData) return;

    var idInput = form.querySelector("[data-variant-id-input]");
    if (!idInput) return;

    function applyVariant(variant) {
      updateVariantInForm(form, variant, productData);
      updateGalleryImage(section, variant);
      syncHwSelect(form, variant);
      syncSelectedValueDisplay(form, variant);
    }

    function onOptionChange() {
      var opts = getSelectedOptions(form);
      var variant =
        findVariantByOptions(productData, opts) ||
        productData.product.variants[0];
      applyVariant(variant);
    }

    form.addEventListener("change", function (e) {
      if (e.target.matches("input[data-option-position]")) {
        onOptionChange();
      }
    });

    section.addEventListener("click", function (e) {
      var target = e.target.closest('[data-action="toggle-popover"]');
      if (target) {
        e.preventDefault();
        var popoverId = target.getAttribute("aria-controls");
        var popover = popoverId ? document.getElementById(popoverId) : null;
        if (popover) {
          var isOpen = popover.getAttribute("aria-hidden") !== "true";
          popover.setAttribute("aria-hidden", isOpen ? "true" : "false");
          target.setAttribute("aria-expanded", isOpen ? "false" : "true");
        }
        return;
      }

      target = e.target.closest('[data-action="close-popover"]');
      if (target) {
        e.preventDefault();
        var popover = target.closest(".OptionSelector, .VariantSelector");
        if (popover) {
          popover.setAttribute("aria-hidden", "true");
          var trigger = form.querySelector(
            '[aria-controls="' + (popover.id || "") + '"]',
          );
          if (trigger) trigger.setAttribute("aria-expanded", "false");
        }
        return;
      }

      target = e.target.closest('[data-action="select-value"]');
      if (target) {
        e.preventDefault();
        var value = target.getAttribute("data-value");
        var pos = parseInt(target.getAttribute("data-option-position"), 10);
        var name = "option-" + (pos - 1);
        var radios = form.querySelectorAll('input[name="' + name + '"]');
        for (var r = 0; r < radios.length; r++) {
          if (radios[r].value === value) {
            radios[r].checked = true;
            break;
          }
        }
        var popover = target.closest(".OptionSelector, .VariantSelector");
        if (popover) {
          var triggerBtn = form.querySelector(
            '[aria-controls="' + (popover.id || "") + '"]',
          );
          if (triggerBtn) {
            var selectedValSpan = triggerBtn.querySelector(
              ".ProductForm__SelectedValue",
            );
            if (selectedValSpan) selectedValSpan.textContent = value || "";
            triggerBtn.setAttribute("aria-expanded", "false");
          }
          popover.setAttribute("aria-hidden", "true");
        }
        target.closest(".Popover__ValueList") &&
          target
            .closest(".Popover__ValueList")
            .querySelectorAll(".Popover__Value")
            .forEach(function (b) {
              b.classList.toggle("is-selected", b === target);
            });
        var choice = target.closest(".VariantSelector__Choice");
        if (choice) {
          choice.parentElement
            .querySelectorAll(".VariantSelector__Choice")
            .forEach(function (c) {
              c.classList.remove("is-selected");
            });
          choice.classList.add("is-selected");
        }
        onOptionChange();
        return;
      }

      target = e.target.closest(".VariantSelector__Choice");
      if (target && !target.classList.contains("is-selected")) {
        var list = target.parentElement;
        if (list) {
          list
            .querySelectorAll(".VariantSelector__Choice")
            .forEach(function (c) {
              c.classList.remove("is-selected");
            });
          target.classList.add("is-selected");
        }
        return;
      }

      target = e.target.closest('[data-action="select-variant"]');
      if (target) {
        e.preventDefault();
        var selector = target.closest(".VariantSelector");
        if (selector) {
          var selectedChoice = selector.querySelector(
            ".VariantSelector__Choice.is-selected",
          );
          if (selectedChoice) {
            var valEl = selectedChoice.querySelector(
              ".VariantSelector__ChoiceValue",
            );
            var optEl = selector.querySelector("[data-option-position]");
            var optPos = optEl
              ? parseInt(optEl.getAttribute("data-option-position"), 10)
              : 1;
            var name = "option-" + (optPos - 1);
            var valStr = valEl ? valEl.textContent.trim() : "";
            var radios = form.querySelectorAll('input[name="' + name + '"]');
            for (var r = 0; r < radios.length; r++) {
              if (radios[r].value === valStr) {
                radios[r].checked = true;
                break;
              }
            }
            var trigger = form.querySelector(
              '[aria-controls="' + (selector.id || "") + '"]',
            );
            if (trigger) {
              var span = trigger.querySelector(".ProductForm__SelectedValue");
              if (span) span.textContent = valStr || "";
              trigger.setAttribute("aria-expanded", "false");
            }
            onOptionChange();
          }
          selector.setAttribute("aria-hidden", "true");
        }
        return;
      }

      target = e.target.closest('[data-action="increase-quantity"]');
      if (target) {
        e.preventDefault();
        var qtyInput = form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          var v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, v + 1);
        }
        return;
      }

      target = e.target.closest('[data-action="decrease-quantity"]');
      if (target) {
        e.preventDefault();
        var qtyInput = form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          var v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, v - 1);
        }
        return;
      }
    });

    var hwSelect = document.querySelector(".hw--select select");
    if (hwSelect) {
      hwSelect.addEventListener("change", function () {
        var selectedValue =
          this.options[this.selectedIndex] &&
          this.options[this.selectedIndex].getAttribute("orig-value");
        if (!selectedValue) return;
        var optPos = 1;
        var optionInputs = form.querySelectorAll(
          'input[data-option-position="1"]',
        );
        for (var k = 0; k < optionInputs.length; k++) {
          if (optionInputs[k].value === selectedValue) {
            optionInputs[k].checked = true;
            onOptionChange();
            break;
          }
        }
      });
    }
  }

  function init() {
    var section = document.querySelector(PRODUCT_SECTION);
    if (section) initProductForm(section);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", function (e) {
    var section =
      e.target.querySelector && e.target.querySelector(PRODUCT_SECTION);
    if (section) initProductForm(section);
    else if (e.target.matches && e.target.matches(PRODUCT_SECTION))
      initProductForm(e.target);
  });
})();
